<script>
import WebLayout from '@/layouts/Web/Layout.vue'

export default {
  // Using shorthand syntax...
  layout: WebLayout,
}
</script>

<script setup>
import Landing from '@/Pages/Web/Home/Landing.vue'
import Categories from '@/Pages/Web/Home/Categories.vue'
import FeaturedServices from '@/Pages/Web/Home/FeaturedServices.vue'
import HowItWorks from '@/Pages/Web/Home/HowItWorks.vue'
import JoinUs from '@/Pages/Web/Home/JoinUs.vue'
import Blog from '@/Pages/Web/Home/Blog.vue'
import MediaSection from '@/Pages/Web/Home/MediaSection.vue'
import SendQuestion from '@/Pages/Web/Home/SendQuestion.vue'
import SEOHead from '@/components/SEOHead.vue'
</script>

<template>
    <SEOHead
        title="Lexo - Povezujemo vas s pravnimi storitvami"
        description="Dinamična platforma, ki vas povezuje z lokalnimi pravnimi in upravnimi strokovnjaki na različnih področjih, od pravnih storitev, kot je družinsko in lastninsko pravo, do administrativne podpore."
        keywords="pravne storitve, odvetniki, notarji, cenilci, stečajni upravitelji, pravno svetovanje, Slovenija, Lexo"
        canonical="/"
        image="/images/web/lexo-home.png"
        :structured-data="{
            '@type': 'WebSite',
            'name': 'Lexo',
            'url': 'https://lexo.si',
            'description': 'Dinamična platforma, ki vas povezuje z lokalnimi pravnimi in upravnimi strokovnjaki',
            'potentialAction': {
                '@type': 'SearchAction',
                'target': 'https://lexo.si/search?q={search_term_string}',
                'query-input': 'required name=search_term_string'
            }
        }"
    />
    <Landing />
    <Categories />
    <HowItWorks />
    <FeaturedServices v-if="false"/>
    <MediaSection />
    <JoinUs />
    <Blog />
    <SendQuestion />
</template>
